import React, { useState } from "react";
import { Link } from "react-router-dom";
import { CheckIcon } from "lucide-react";
import { Logo } from "./Logo";
import { navLinks } from "../data/site";
type Status = "idle" | "error" | "success";
export function Footer() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<Status>("idle");
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    setStatus(/^\S+@\S+\.\S+$/.test(email) ? "success" : "error");
  };
  return <footer className="p-3 pt-24 md:p-5 md:pt-32" data-id="element-16" data-mp="3991omvfnkca">
      <div className="mx-auto max-w-[1320px] px-2 pb-20 md:px-5" data-id="element-17" data-mp="37xvkgeim0i0">
        <div className="grid gap-10 lg:grid-cols-2 lg:items-end" data-id="element-18" data-mp="3ldanjfu8c3jw">
          <h2 className="font-serif text-4xl leading-[1.1] md:text-6xl" data-id="element-19" data-mp="3qd6pzana3mxc">
            Ne manquez pas <span className="italic" data-id="element-20" data-mp="29z6ss7ftibds">le décollage.</span>
          </h2>
          <form onSubmit={submit} noValidate className="w-full" data-id="element-21" data-mp="29xvrqfdrbhqd">
            <label htmlFor="newsletter" className="text-navy-soft" data-id="element-22" data-mp="2ezbbm4477i76">
              Recevez les annonces du programme et l'ouverture des inscriptions.
            </label>
            {status === "success" ? <p className="mt-4 flex items-center gap-3 rounded-full bg-lime px-6 py-4 font-medium" role="status" data-id="element-23" data-mp="3gbr0cm0dsxe2">
                <CheckIcon className="h-5 w-5" data-id="element-24" data-mp="3v9axj6r1do9o" /> Merci ! Vous êtes inscrit·e.
              </p> : <div className="mt-4 flex rounded-full border border-navy/20 bg-white p-1.5 focus-within:border-navy" data-id="element-25" data-mp="3qapz9cvchenv">
                <input id="newsletter" type="email" value={email} onChange={e => {
              setEmail(e.target.value);
              setStatus("idle");
            }} placeholder="votre@email.fr" aria-invalid={status === "error"} aria-describedby={status === "error" ? "newsletter-error" : undefined} className="min-w-0 flex-1 bg-transparent px-5 text-navy placeholder:text-navy/40 focus:outline-none" data-id="element-26" data-mp="33xe1y3atysi" />
                <button type="submit" className="whitespace-nowrap rounded-full bg-navy px-6 py-3 font-semibold text-cream transition-colors duration-150 hover:bg-navy-soft" data-id="element-27" data-mp="tt9z0dyrgtw6">
                  S'inscrire
                </button>
              </div>}
            {status === "error" && <p id="newsletter-error" className="mt-2 pl-5 text-sm text-wing" data-id="element-28" data-mp="18lu0la69itbi">
                Merci de saisir une adresse e-mail valide.
              </p>}
          </form>
        </div>
      </div>

      <div className="rounded-[28px] bg-navy text-cream md:rounded-[36px]" data-id="element-29" data-mp="1mjsb24hgq5lq">
        <div className="mx-auto flex max-w-[1320px] flex-col gap-10 px-6 py-12 md:flex-row md:items-start md:justify-between md:px-10" data-id="element-30" data-mp="1mhpbotuf704c">
          <div className="max-w-xs" data-id="element-31" data-mp="3obomle3mrfgi">
            <Logo light data-id="element-32" data-mp="3ocgfui9r913m" />
            <p className="mt-4 text-sm leading-relaxed text-cream/70" data-id="element-33" data-mp="3od85zdkl26mi">
              Association organisatrice du 50ème anniversaire du parapente. Mieussy, Haute-Savoie — berceau mondial du parapente.
            </p>
          </div>
          <nav aria-label="Pied de page" data-id="element-34" data-mp="25onb1tw66vrg">
            <ul className="grid grid-cols-2 gap-x-12 gap-y-3 text-sm" data-id="element-35" data-mp="25mu74mcxypn5">
              {navLinks.map(l => <li key={l.to} data-id="element-36" data-mp="21n1spt0v9p9v">
                  <Link to={l.to} className="text-cream/80 transition-colors duration-150 hover:text-lime" data-id="element-37" data-mp="1wnp5h7632g6r">
                    {l.label}
                  </Link>
                </li>)}
            </ul>
          </nav>
        </div>
        <div className="mx-auto max-w-[1320px] border-t border-cream/15 px-6 py-6 text-sm text-cream/60 md:px-10" data-id="element-38" data-mp="2pdpglnr6gpi2">
          © 2026 Association Mieussy 2028 · 74440 Mieussy
        </div>
      </div>
    </footer>;
}